import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW7100Model } from "../kymw7100.model";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { Injectable } from "@angular/core";
import { GetBundleCatalogRoundInfoService } from "./get-bundle-catalog-round-info.service";

export type RegistBundleCatalogRoundInfoResponse = {
  BundleCatalogRoundId: string,
}[];

/**
 * 束ね企画回を登録するサービス
 *
 * @export RegistBundleCatalogRoundInfoService
 * @class RegistBundleCatalogRoundInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistBundleCatalogRoundInfoService extends PlessJsonResponderSub<RegistBundleCatalogRoundInfoResponse> {
  private model: KYMW7100Model;
  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
    private getBundleCatalogRoundInfoService: GetBundleCatalogRoundInfoService
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   * 
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistBundleCatalogRoundInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MediumType: this.model.formData.mediumType,
        StartOrderCode: this.model.formData.startOrderCode,
        EndOrderCode: this.model.formData.endOrderCode,
        BundleCatalogRoundName: this.model.formData.bundleCatalogName
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistBundleCatalogRoundInfoService
   */
  execute(model: KYMW7100Model) {
    this.model = model;
    this.send('registBundleCatalogRoundInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof RegistBundleCatalogRoundInfoService 
   */
  success() {
    this.getBundleCatalogRoundInfoService.execute(this.model);
    this.model.kymw7100Component.setRowBackgroundColor();
    this.model.clearFormData();
  }
}